import {
  Flex,
  Layout
} from "antd";
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header/header";
import Footer from "./Footer/footer";

const { Content } = Layout;

const NotFound = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Flex
      vertical
      justify="center"
      style={{
        minHeight: "100vh",
      }}
    >
      <Header/>
      <Content className="mt-[88px] relative z-[1] flex-grow-1">
        {children}
      </Content>
      <Footer/>
    </Flex>
  );
};

export default NotFound;
